module.exports = __webpack_public_path__ + "img/freshest-flick-thai.eec9bf51.png";